export const userActionTypes={
    SET_CURRENT_THEME_MODE:"SET_CURRENT_THEME_MODE"
}

